import Image from 'next/legacy/image';

import styles from './imageBanner.module.css';

const ImageBanner = ({image, children}) => (
  <div
    className={styles.app__image_banner}
    id={`image_banner`}>
    <Image
      src={image}
      alt={`bannerImage`}
      layout="fill"
      objectFit="cover"
    />
    <div className={styles.app__image_banner_content}>{children}</div>
  </div>
);

export default ImageBanner;
